import { gql } from "@apollo/client";

export const CreateIoTConnection = gql`
    mutation CreateIoTConnection ($assetLocationId: ID!, $input: IoTConnectionCreateAttributesInput!) {
        createIoTConnection (assetLocationId: $assetLocationId, input: $input) {
            id
        }
    }
`;
